import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Provider } from '../../common/ComponentIdContext';
import { ComponentNameProvider } from '../../common/ComponentNameContext';
import ConstCommon from '../../common/Const';
import { isNotLogin, removeDragCode } from '../../helpers/Common';
import AlertHistory from './history';
import { fetchPersonalAlertTypes, REDUCER_NAME } from './reducer';
import SettingPopup from './SettingPopup';
import { compose } from 'redux';
import PreRender from './../../common/PreRender';
import ScrollComponent from '../../common/ScrollComponent';
import './index.scss';

class Alerts extends Component {
  constructor(props) {
    super(props);
    this.toolAlertsRef = React.createRef();
    this.state = {
      isShowSetting: false,
    };
  }

  componentDidMount() {
    const { glContainer, fetchPersonalAlertTypes, user } = this.props;
    removeDragCode(glContainer);
    if (!isNotLogin(user)) {
      fetchPersonalAlertTypes();
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { locale, fetchPersonalAlertTypes } = this.props;
    if (locale !== prevProps.locale) {
      fetchPersonalAlertTypes();
    }
  }

  showSetting = (bool = true) => {
    this.setState({
      isShowSetting: bool,
    });
  };

  render() {
    const { isShowSetting } = this.state;
    const { id } = this.props;
    return (
      <PreRender {...this.props}>
        <ComponentNameProvider value={ConstCommon.listComponent.Alerts}>
          <Provider value={id}>
            <ScrollComponent>
              <div className="px-20 pt-8 h-100 d-flex flex-column tools-alerts">
                <div className="top-nav flex-fill d-flex flex-column h-auto">
                  <div className="tab-content h-auto flex-fill d-flex flex-column mb-10">
                    <div
                      className="d-flex flex-column flex-fill"
                      ref={this.toolAlertsRef}
                    >
                      <AlertHistory
                        isShowSetting={isShowSetting}
                        showSetting={this.showSetting}
                        parentRef={this.toolAlertsRef}
                      />
                    </div>
                  </div>
                </div>
                {isShowSetting && (
                  <SettingPopup showSetting={this.showSetting} />
                )}
              </div>
            </ScrollComponent>
          </Provider>
        </ComponentNameProvider>
      </PreRender>
    );
  }
}

const mapStateToProps = state => ({
  currentTab: state[REDUCER_NAME].currentTab,
  locale: state.i18n.locale,
  user: state.userInfo,
});

const mapDispatchToProps = {
  fetchPersonalAlertTypes,
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(Alerts);
